import BotResponseTreeNode from './BotResponseTreeNode';

class IntentTreeNode {
  sampleUtterances: string[];

  nextStep: BotResponseTreeNode | null;

  constructor(
    sampleUtterances: string[],
    nextStep: BotResponseTreeNode | null
  ) {
    this.sampleUtterances = sampleUtterances;
    this.nextStep = nextStep;
  }
}

export default IntentTreeNode;
